// extracted by mini-css-extract-plugin
export default {"card":"styles_card__4B6AY","text":"styles_text__cGLb3","line":"styles_line__73qHm","lineNumber":"styles_lineNumber__V4CdY","textMuted":"styles_textMuted__W7zJw"};